import { ArrowLeft } from "lucide-react";
import SEO from "@/components/SEO";
import LonghandWorkspaceSetup from "@/components/training/LonghandWorkspaceSetup";
import {
  LONGHAND_OPTIONAL_BUILD_SETUP_STEPS,
  LONGHAND_WORKSPACE_SETUP_STEPS,
} from "@/data/longhandWorkspaceSetup";
import "./LonghandAIProgram.css";

const LonghandAIPrep = () => {
  const allSetupSteps = [
    ...LONGHAND_WORKSPACE_SETUP_STEPS,
    ...LONGHAND_OPTIONAL_BUILD_SETUP_STEPS,
  ];
  const howToSchema = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    name: "Prepare Your AI Workspace",
    description: "Set up an approved Claude or ChatGPT workspace, then optionally connect a local coding project to GitHub and Vercel.",
    url: "https://www.technical-leaders.com/ai-30/program/prep",
    step: allSetupSteps.map((step) => ({
      "@type": "HowToStep",
      name: step.title,
      url: `https://www.technical-leaders.com/ai-30/program/prep#${step.id}`,
    })),
  };

  return (
    <div className="lhp-page">
      <SEO
        title="Prepare Your AI Workspace | Longhand AI Atlas"
        description="Prepare Claude or ChatGPT, then optionally connect a coding project to GitHub and Vercel for reviewable preview deployments."
        keywords={["Longhand AI", "AI workspace setup", "Claude Code setup", "Codex Desktop setup", "GitHub setup", "Vercel setup"]}
        structuredData={howToSchema}
      />

      <a className="lhp-skip" href="#prepare">Skip to the setup steps</a>

      <header className="lhp-site-header">
        <a href="/ai-30/program" className="lhp-brand" aria-label="Back to the Longhand AI roadmap">
          <img src="/orange-logo.png" alt="Tech Leaders" width="170" height="38" />
        </a>
        <nav aria-label="Prep navigation">
          <a href="/ai-30/program/atlas"><ArrowLeft aria-hidden="true" /> Atlas</a>
          <a href="/ai-30/program">Roadmap</a>
          <a href="/ai-30/program#ai-tune-up">AI Tune-Up</a>
        </nav>
      </header>

      <main id="prep-guide">
        <LonghandWorkspaceSetup />
      </main>

      <footer className="lhp-footer">
        <a href="/ai-30/program" className="lhp-brand"><img src="/orange-logo.png" alt="Tech Leaders" width="170" height="38" /></a>
        <p>Longhand AI · Prepare one approved workspace before building.</p>
      </footer>
    </div>
  );
};

export default LonghandAIPrep;
